import { render } from "./gcs.vue?vue&type=template&id=353615b0&scoped=true"
import script from "./gcs.vue?vue&type=script&lang=js"
export * from "./gcs.vue?vue&type=script&lang=js"

import "./gcs.vue?vue&type=style&index=0&id=353615b0&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353615b0"]])

export default __exports__